<template>
    <header id="fluke-header" v-if="notlogin">
        <div class="container">
            <!-- // Mobile Menu -->
            <div class="menu-icon">
                <i class="material-icons">
                    menu
                </i>
            </div>

            <!-- Title and Breadcurmbs -->
            <div class="left-items">
                <h1 class="title">{{ title }}</h1>
                <div id="breadcrumbs">
                    <ul>
                        <li v-for="( item, index ) in breadcrumbs" v-bind:key="index">
                            <a v-if="item.active" v-bind:href="item.link">{{item.title}}</a>
                            <a v-else v-html="item.title" class="active"></a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- // Right Menu -->
            <div class="login-icon">
                <router-link to="/users">
                    <i class="material-icons">
                        person
                    </i>
                </router-link>

                <a
                    href="#"
                    class="toggle-notifications"
                    @click.prevent="toggleNotifications"
                >
                    <span
                        v-if="notificationsCounter"
                        class="toggle-notifications__counter"
                    >{{ notificationsCounter }}</span>
                    <i class="material-icons">
                        notifications
                    </i>
                </a>

                <a v-on:click="logout">
                    <i class="material-icons">
                        exit_to_app
                    </i>
                </a>
            </div>
            <fluke-notifications
                :opened="notificationsOpened"
                :list="notifications"
                :loading="isLoadingNotifications"
                :unread-count="notificationsCounter"
                @click="onNotificationClick"
                @read-all="markAllNotificationsAsRead"
            ></fluke-notifications>
        </div>
    </header>
</template>

<script>
import axios from 'axios'
import NotificationsVue from './Notifications.vue'
export default {
    components: {
        'fluke-notifications': NotificationsVue
    },
    data: function () {
        return {
            notlogin: true,
            title: 'home',
            breadcrumbsControlArray: {
                'home': [],
                'courses': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CURSOS', link: '', active: false }
                ],
                'courses-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CURSOS', link: '/courses', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR CURSO', link: '', active: false }
                ],
                'courses-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CURSOS', link: '/courses', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR CURSO', link: '', active: false }
                ],
                'events': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EVENTOS', link: '', active: false }
                ],
                'events-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EVENTOS', link: '/events', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR EVENTO', link: '', active: false }
                ],
                'events-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EVENTOS', link: '/events', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR EVENTO', link: '', active: false }
                ],
                'blog': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '', active: false },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'POSTS', link: '', active: false }
                ],
                'blog-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'POSTS', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR POST', link: '', active: false }
                ],
                'blog-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'POSTS', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR POST', link: '', active: false }
                ],
                'blog-categories': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CATEGORIAS', link: '', active: false },
                ],
                'blog-categories-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CATEGORIAS', link: '/blog/categories', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR CATEGORIA', link: '', active: false }
                ],
                'blog-categories-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CATEGORIAS', link: '/blog/categories', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR CATEGORIA', link: '', active: false }
                ],
                'blog-comments': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'BLOG', link: '/blog', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'COMENTÁRIOS', link: '', active: false },
                ],
                'news': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'NEWSLETTER', link: '', active: false }
                ],
                'contacts': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'CONTATOS', link: '', active: false }
                ],
                'pages': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'PÁGINAS', link: '', active: false }
                ],
                'pages-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'PÁGINAS', link: '/pages', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR PÁGINA', link: '', active: false }
                ],
                'pages-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'PÁGINAS', link: '/pages', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR PÁGINA', link: '', active: false }
                ],
                'menu': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'MENU', link: '', active: false }
                ],
                'menu-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'MENU', link: '/menu', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR', link: '', active: false }
                ],
                'menu-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'MENU', link: '/menu', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR', link: '', active: false }
                ],
                'images': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'IMAGENS', link: '', active: false }
                ],
                'students': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ALUNOS', link: '', active: false }
                ],
                'students-request-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ALUNOS', link: '/students', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'REQUISIÇÃO', link: '', active: false }
                ],
                'students-edit': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ALUNOS', link: '/students', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'EDITAR ALUNO', link: '', active: false }
                ],
                'students-add': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ALUNOS', link: '/students', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'ADICIONAR ALUNO', link: '', active: false }
                ],
                'user_logs': [
                    { title: 'HOME', link: '/', active: true },
                    { title: '<i class="material-icons">keyboard_arrow_right</i>', link: '', active: false },
                    { title: 'LOGS DO SISTEMA', link: '', active: false }
                ],
            },
            breadcrumbs: [],
            notificationsOpened: false,
        }
    },
    watch: {
        '$route': 'headerTitleHandler',
        '$store.state.loggedIn': 'onChangeLoggedIn'
    },
    mounted: function() {
        this.headerTitleHandler()
        this.onChangeLoggedIn(this.$store.state.loggedIn)
    },
    beforeDestroy: function () {
        if  (this.notificationInterval) {
            clearInterval(this.notificationInterval)
        }
    },
    methods: {
        logout: function() {
			this.$store.state.loggingOut = true
			this.$router.push('/login')
		},
        headerTitleHandler: function () {
            var title = this.$route.name

            if (
                title === 'login' ||
                title === 'passwordRecovery' ||
                title === 'changePassword'
            ) {
                this.notlogin = false
            } else {
                this.notlogin = true
            }

            this.breadcrumbs = ( typeof this.breadcrumbsControlArray[title] === 'undefined' )?[]:this.breadcrumbsControlArray[title]
            switch (title) {
                case 'home':
                    this.title = 'Dashboard Home';
                    break;
                case 'about':
                    this.title = 'About';
                    break;
                case 'login':
                    this.title = 'Login';
                    break;
                case 'courses':
                    this.title = 'Cursos';
                    break;
                case 'courses-add':
                    this.title = 'Cursos';
                    break;
                case 'courses-edit':
                    this.title = 'Cursos';
                    break;
                case 'faq':
                    this.title = 'FAQ';
                    break;
                case 'faq-add':
                    this.title = 'FAQ';
                    break;
                case 'faq-edit':
                    this.title = 'FAQ';
                    break;
                case 'events':
                    this.title = 'Eventos';
                    break;
                case 'events-add':
                    this.title = 'Eventos';
                    break;
                case 'events-edit':
                    this.title = 'Eventos';
                    break;
                case 'blog':
                    this.title = 'Blog';
                    break;
                case 'blog-add':
                    this.title = 'Blog';
                    break;
                case 'blog-edit':
                    this.title = 'Blog';
                    break;
                case 'blog-categories':
                    this.title = 'Blog';
                    break;
                case 'blog-categories-add':
                    this.title = 'Blog';
                    break;
                case 'blog-categories-edit':
                    this.title = 'Blog';
                    break;
                case 'blog-comments':
                    this.title = 'Blog';
                    break;
                case 'pages':
                    this.title = 'Páginas';
                    break;
                case 'pages-add':
                    this.title = 'Páginas';
                    break;
                case 'pages-edit':
                    this.title = 'Páginas';
                    break;
                case 'contacts':
                    this.title = 'Contatos';
                    break;
                case 'contacts-edit':
                    this.title = 'Contatos';
                    break;
                case 'news':
                    this.title = 'Newsletter';
                    break;
                case 'users':
                    this.title = 'Usuários';
                    break;
                case 'users-add':
                    this.title = 'Usuários';
                    break;
                case 'users-edit':
                    this.title = 'Usuários';
                    break;
                case 'users-pass':
                    this.title = 'Usuários';
                    break;
                case 'users-reset':
                    this.title = 'Usuários';
                    break;
                case 'menu':
                    this.title = 'Menu';
                    break;
                case 'menu-add':
                    this.title = 'Menu';
                    break;
                case 'menu-edit':
                    this.title = 'Menu';
                    break;
                case 'images':
                    this.title = 'Imagens';
                    break;
                case 'students':
                    this.title = 'Alunos Certificados';
                    break;
                case 'students-request-edit':
                    this.title = 'Alunos Certificados';
                    break;
                case 'students-add':
                    this.title = 'Alunos Certificados';
                    break;
                case 'students-edit':
                    this.title = 'Alunos Certificados';
                    break;
                case 'user_logs':
                    this.title = 'Logs do sistema';
                    break;
                case 'students_terms':
                    this.title = 'Termo de Consentimento';
                    break;
                case 'term_files':
                    this.title = 'Gerenciar PDF Termos';
                    break;
                case 'term_files_add':
                    this.title = 'Adicionar Novo PDF';
                    break;
                default:
                    this.title = 'Carregando...';
            }
        },
        toggleNotifications () {
            const { notification } = this.$store.state
            this.notificationsOpened = !this.notificationsOpened
            if (
                this.notificationsOpened &&
                !notification.list.loadingList &&
                notification.list.length === 0
            ) {
                this.loadNotifications();
            }
        },
        onChangeLoggedIn (loggedIn) {
            if (loggedIn) {
                this.loadNotificationsUnreadCount();
                this.notificationInterval = setInterval(() => {
                    this.loadNotificationsUnreadCount()
                }, 1000 * 30)
            } else {
                if (this.notificationInterval) {
                    clearInterval(this.notificationInterval)
                }
            }
        },
        async loadNotificationsUnreadCount () {
            try {
                const { notification } = this.$store.state
                const result = await axios.get(
                    this.$myServerAddresses.notifications + 'notifications/unread-count',
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    }
                );
                const load = (
                    +result.data.count > notification.unreadCount &&
                    this.notificationsOpened
                )
                this.$store.commit('set_notification_unread_count', result.data);
                if (load) {
                    this.loadNotifications()
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        async loadNotifications () {
            try {
                const result = await axios.get(
                    this.$myServerAddresses.notifications + 'notifications',
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        },
                    }
                );
                this.$store.commit('set_notifications', result.data);
            } catch (error) {
                console.log(error.message)
            }
        },
        async onNotificationClick (notification) {
            this.toggleNotifications()
            if (notification.unread) {
                try {
                    const { data } = await axios.put(
                        this.$myServerAddresses.notifications + 'notifications/' + notification.id,
                        {},
                        {
                            headers: {
                                'X-Fluke': this.$cookies.get('token')
                            },
                        }
                    );
                    if (data.success) {
                        this.$store.commit('set_notification_read', notification);
                    }
                } catch (error) {
                    console.log(error.message)
                }
            }
        },
        async markAllNotificationsAsRead () {
            this.toggleNotifications()
            try {
                const { data } = await axios.put(
                    this.$myServerAddresses.notifications + 'notifications/read-all',
                    {},
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        },
                    }
                );
                if (data.success) {
                    this.$store.commit('set_all_notifications_read');
                }
            } catch (error) {
                console.log(error.message)
            }
        }
    },
    computed: {
        notifications () {
            const { notification } = this.$store.state
            return notification.list
        },
        notificationsCounter () {
            const { notification } = this.$store.state
            return notification.unreadCount > 9
                ? `+9`
                : notification.unreadCount
        },
        isLoadingNotifications () {
            const { notification } = this.$store.state
            return notification.loadingList
        }
    }
}
</script>

<style lang="scss">
header#fluke-header {
    height: 100px;
    display: flex !important;
    align-items: center;
    padding: 0 0 0 20px;

    .container {
        position: relative;
        display: flex;
    }

    h1.title {
        font-size: 30px !important;
        font-weight: 100;
        text-rendering: optimizeLegibility;
    }
    h1.title,
    div.menu-icon {
        float: left;
    }
    #breadcrumbs {
        clear: left;

        ul {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                float: left;

                a {
                    text-decoration: none;
                    color: inherit;
                    font-size: 11px;

                    &.active {
                        font-weight: 500;
                    }

                    i.material-icons {
                        font-size: 12px;
                        line-height: 17px;
                    }
                }

            }
        }
    }
    .menu-icon {
        margin-right: 10px;
        display: none;

        @media ( max-width: $mobile-size )
        {
            display: block;
        }
    }
    .left-items {
        display: inline-block;
    }
    .login-icon {
        margin-left: auto;
        padding-right: 10px;
        float: right;
        margin-top: 5px;
        flex-shrink: 0;

        a {
            margin-left: 10px;
            color: #495057;
        }
    }
    .toggle-notifications {
        position: relative;
        text-decoration: none;
        &__counter {
            position: absolute;
            top: -18px;
            right: -5px;
            width: 18px;
            height: 18px;
            border-radius: 9px;
            background: #eb3a3a;
            color: white;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
        }
    }
}
</style>
